<script lang="ts">
  interface Props {
    level?: 1 | 2 | 3;
    variant?: "screen" | "section" | "group" | "sr-only";
    margin?: boolean;
    id?: string;
    class?: string;
    children?: import("svelte").Snippet;
  }

  let {
    level = 2,
    variant = "section",
    margin = true,
    id = undefined,
    class: className,
    children,
  }: Props = $props();

  const HeadingTag = $derived(`h${level}`);

  const variantClasses: Record<NonNullable<Props["variant"]>, string> = {
    screen: "block text-H3 md:text-H2 font-black",
    section: "block text-H4 md:text-H3 font-bold",
    group: "group-label",
    "sr-only": "sr-only",
  };
</script>

<svelte:element
  this={HeadingTag}
  {id}
  class="{className} {variant !== 'sr-only' && margin ? 'mb-2' : ''} {variantClasses[variant]}"
>
  {@render children?.()}
</svelte:element>
